module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 18
// module chunks = 0